import React, { useState } from 'react';
import { API_BASE } from '../api/config';

const DataExportSection: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleExport = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await fetch(`${API_BASE}/api/Account/export`, {
        credentials: 'include',
      });

      if (!response.ok) throw new Error(`Request failed: ${response.status}`);

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'buildon-data-export.json';
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      setError('Export failed. Please try again or contact privacy@buildon.co.za.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mt-10 pt-8 border-t border-outline-variant">
      <h2 className="text-lg font-semibold text-on-surface mb-1">Download your data</h2>
      <p className="text-sm text-on-surface-variant mb-4">
        Under POPIA you have the right to receive a copy of your personal information. This export
        includes your account details, profile, messages, reviews, jobs, favourites, and newsletter
        preferences as a JSON file.
      </p>
      <button
        onClick={handleExport}
        disabled={loading}
        className="flex items-center gap-2 px-4 py-2 rounded-lg border border-outline-variant text-on-surface text-sm font-semibold hover:bg-surface-container active:scale-95 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <span className="material-symbols-outlined text-[18px]">
          {loading ? 'progress_activity' : 'download'}
        </span>
        {loading ? 'Preparing export...' : 'Download my data'}
      </button>
      {error && <p className="text-sm text-error mt-3">{error}</p>}
    </section>
  );
};

export default DataExportSection;
